export enum DeprecatedProjectId {
    AccordionDoorInstallation = 'accordionDoorInstallation',
    AcousticCabinsAndPhoneBox = 'acousticCabinsAndPhoneBox',
    AlluminiumFenceInstallation = 'alluminiumFenceInstallation',
    AluminiumCarpentry = 'aluminiumCarpentry',
    AluminiumCladding = 'aluminiumCladding',
    AluminiumFenceInstallation = 'aluminiumFenceInstallation',
    AluminiumFenceRepair = 'aluminiumFenceRepair',
    AnticyclonicShutterInstallation = 'anticyclonicShutterInstallation',
    AnticyclonicShutterRepair = 'anticyclonicShutterRepair',
    ApartementRenovation = 'apartementRenovation',
    ArchitectHouse = 'architectHouse',
    Armchair = 'armchair',
    Asphalting = 'asphalting',
    AsphaltShingleRoof = 'asphaltShingleRoof',
    AtticLayout = 'atticLayout',
    AtticRenovation = 'atticRenovation',
    AutomaticGateInstallation = 'automaticGateInstallation',
    AutomaticPortalInstallation = 'automaticPortalInstallation',
    AwningCleaning = 'awningCleaning',
    AwningInstallation = 'awningInstallation',
    AwningRepair = 'awningRepair',
    BabyRoomDesign = 'babyRoomDesign',
    BalconyBuild = 'balconyBuild',
    BalconyRepair = 'balconyRepair',
    BalconyWaterproofing = 'balconyWaterproofing',
    BarCounter = 'barCounter',
    BathroomDesign = 'bathroomDesign',
    BathroomInstallation = 'bathroomInstallation',
    BathroomRenovation = 'bathroomRenovation',
    Bedding = 'bedding',
    BedroomLayout = 'bedroomLayout',
    Bench = 'bench',
    BenchAndBench = 'benchAndBench',
    BilliardRepair = 'billiardRepair',
    BlindAndRollerShutter = 'blindAndRollerShutter',
    BlindSale = 'blindSale',
    BrickFacing = 'brickFacing',
    BrickRepair = 'brickRepair',
    BrickSale = 'brickSale',
    Brickyard = 'brickyard',
    CarpetCleaning = 'carpetCleaning',
    CarpetLaying = 'carpetLaying',
    CarpetRepair = 'carpetRepair',
    CarpetSale = 'carpetSale',
    CarpetStretch = 'carpetStretch',
    CarportBuild = 'carportBuild',
    Caulking = 'caulking',
    CeilingFanInstallation = 'ceilingFanInstallation',
    CeilingFanRepair = 'ceilingFanRepair',
    CellarWaterproofing = 'cellarWaterproofing',
    Chair = 'chair',
    ChaletBuild = 'chaletBuild',
    ChangingThePoolLiner = 'changingThePoolLiner',
    ChildAndBabyRoom = 'childAndBabyRoom',
    ChildBedroomLayout = 'childBedroomLayout',
    ChimneyBuild = 'chimneyBuild',
    ChimneyDiagnosis = 'chimneyDiagnosis',
    ChimneyInstallation = 'chimneyInstallation',
    ChimneyRepair = 'chimneyRepair',
    ChimneySale = 'chimneySale',
    ChristmasLight = 'christmasLight',
    CladdingInstallation = 'claddingInstallation',
    Claustras = 'claustras',
    Clearing = 'clearing',
    ClosetAndStorage = 'closetAndStorage',
    ClosetInstallation = 'closetInstallation',
    ClosetMakeover = 'closetMakeover',
    ClosetPainting = 'closetPainting',
    ClosetRenovation = 'closetRenovation',
    ClosetRepair = 'closetRepair',
    ClosingSale = 'closingSale',
    CompleteRenovation = 'completeRenovation',
    CompleteRestaurantLayout = 'completeRestaurantLayout',
    ConcreteBuild = 'concreteBuild',
    ConcreteCaulking = 'concreteCaulking',
    ConcreteDrivewayInstallation = 'concreteDrivewayInstallation',
    ConcreteDrivewaySealing = 'concreteDrivewaySealing',
    ConcreteFloor = 'concreteFloor',
    ConcreteRepair = 'concreteRepair',
    ConcreteSale = 'concreteSale',
    ConcreteTint = 'concreteTint',
    ConcreteWorktop = 'concreteWorktop',
    CreateAndRepairOfStainedGlass = 'createAndRepairOfStainedGlass',
    CurtainCleaning = 'curtainCleaning',
    CustomBeds = 'customBeds',
    CustomBilliard = 'customBilliard',
    CustomBlind = 'customBlind',
    CustomBrazier = 'customBrazier',
    CustomChimney = 'customChimney',
    CustomChimneyMantel = 'customChimneyMantel',
    CustomCloset = 'customCloset',
    CustomCupboardDoor = 'customCupboardDoor',
    CustomCupboards = 'customCupboards',
    CustomEmbroidery = 'customEmbroidery',
    CustomExteriorDoor = 'customExteriorDoor',
    CustomFoldingDoor = 'customFoldingDoor',
    CustomFurniture = 'customFurniture',
    CustomGlassRoofs = 'customGlassRoofs',
    CustomGlassWal = 'customGlassWal',
    CustomInteriorDoor = 'customInteriorDoor',
    CustomKItchenCupboard = 'customKItchenCupboard',
    CustomLoungeBar = 'customLoungeBar',
    CustomMadeVanityUnit = 'customMadeVanityUnit',
    CustomMosquitoNet = 'customMosquitoNet',
    CustomOffice = 'customOffice',
    CustomSauna = 'customSauna',
    CustomShelf = 'customShelf',
    CustomStorage = 'customStorage',
    CustomTvUnit = 'customTvUnit',
    CustomWindow = 'customWindow',
    CustomWorkplan = 'customWorkplan',
    DeckBuild = 'deckBuild',
    DeckLayout = 'deckLayout',
    DecorativeConcrete = 'decorativeConcrete',
    Demolition = 'demolition',
    DockDesingAndBuild = 'dockDesingAndBuild',
    DoorPainting = 'doorPainting',
    DoorRepair = 'doorRepair',
    DoorSale = 'doorSale',
    DoorWindowAndPlinthJoinery = 'doorWindowAndPlinthJoinery',
    DoubleGlazing = 'doubleGlazing',
    DresserSideboard = 'dresserSideboard',
    DrivewayGateInstallation = 'drivewayGateInstallation',
    DrivewayRenovation = 'drivewayRenovation',
    DrivewayRepair = 'drivewayRepair',
    EcologicalBuild = 'ecologicalBuild',
    ElectricChimneyInstallation = 'electricChimneyInstallation',
    ElectricChimneyRepair = 'electricChimneyRepair',
    Elevation = 'elevation',
    EpoxyResinFloor = 'epoxyResinFloor',
    Excavation = 'excavation',
    ExteriorDoorInstallation = 'exteriorDoorInstallation',
    ExteriorLightingDesign = 'exteriorLightingDesign',
    ExteriorPainting = 'exteriorPainting',
    ExteriorShutter = 'exteriorShutter',
    FacadPlasterRepair = 'facadPlasterRepair',
    Facelift = 'facelift',
    FenceInstallation = 'fenceInstallation',
    FenceRepair = 'fenceRepair',
    Fireproofing = 'fireproofing',
    FloorCleaning = 'floorCleaning',
    FloorCoveringInstallation = 'floorCoveringInstallation',
    FloorHeating = 'floorHeating',
    FlooringSale = 'flooringSale',
    FloorPlanForBuildingPermit = 'floorPlanForBuildingPermit',
    FloorPolishing = 'floorPolishing',
    FloorRenovation = 'floorRenovation',
    FloorSanding = 'floorSanding',
    FoldingDoor = 'foldingDoor',
    FrameAndJoinery = 'frameAndJoinery',
    FurnitureDelivery = 'furnitureDelivery',
    FurnitureRepair = 'furnitureRepair',
    FurnitureSale = 'furnitureSale',
    GarageBuild = 'garageBuild',
    GarageDoorInstallation = 'garageDoorInstallation',
    GarageDoorRepair = 'garageDoorRepair',
    GarageDoorSale = 'garageDoorSale',
    GarageDoorSellerAndInstaller = 'garageDoorSellerAndInstaller',
    GarageFlooring = 'garageFlooring',
    GarageFloorRenovation = 'garageFloorRenovation',
    GarageLayout = 'garageLayout',
    GardenFurnitureSale = 'gardenFurnitureSale',
    GardenLightingInstallation = 'gardenLightingInstallation',
    GazChimneyInstallation = 'gazChimneyInstallation',
    GazChimneyRepair = 'gazChimneyRepair',
    GeneralBuildingContractor = 'generalBuildingContractor',
    GlassAndMirrorRepair = 'glassAndMirrorRepair',
    GlassBrickInstallation = 'glassBrickInstallation',
    GlutterRepair = 'glutterRepair',
    GraniteWorktop = 'graniteWorktop',
    Ground = 'ground',
    GuardrailInstallation = 'guardrailInstallation',
    GuardrailRepair = 'guardrailRepair',
    GutterCleaning = 'gutterCleaning',
    GutterInstallation = 'gutterInstallation',
    HeaterSale = 'heaterSale',
    HighPressureWashing = 'highPressureWashing',
    HotelRoomFurniture = 'hotelRoomFurniture',
    HouseExtension = 'houseExtension',
    HouseFoundationBuild = 'houseFoundationBuild',
    InstallationOfAwning = 'installationOfAwning',
    InstallationOfGlazingAndMirror = 'installationOfGlazingAndMirror',
    InstallationOfVanityUnit = 'installationOfVanityUnit',
    InsulationInstallation = 'insulationInstallation',
    InteriorDoorInstallation = 'interiorDoorInstallation',
    InteriorShutter = 'interiorShutter',
    Ironworker = 'ironworker',
    KitchenDesign = 'kitchenDesign',
    KitchenInstallation = 'kitchenInstallation',
    KitchenRenovation = 'kitchenRenovation',
    LaminateFlooringLaying = 'laminateFlooringLaying',
    LaminateFlooringSale = 'laminateFlooringSale',
    LaminateFloorRepair = 'laminateFloorRepair',
    Landscaping = 'landscaping',
    LandscapingSupply = 'landscapingSupply',
    LatticeBuild = 'latticeBuild',
    LayingLightPipe = 'layingLightPipe',
    LayingWoodenFence = 'layingWoodenFence',
    LeatherRepair = 'leatherRepair',
    LevelingAndEarthworks = 'levelingAndEarthworks',
    LevelingGround = 'levelingGround',
    Library = 'library',
    LightingDesign = 'lightingDesign',
    LightingSale = 'lightingSale',
    LigthingInstallation = 'ligthingInstallation',
    LinoleumFlooringInstallation = 'linoleumFlooringInstallation',
    LinoleumFlooringSale = 'linoleumFlooringSale',
    LinoleumFloorRepair = 'linoleumFloorRepair',
    Locksmith = 'locksmith',
    LowEnergyBuilding = 'lowEnergyBuilding',
    LowTable = 'lowTable',
    LuxuryRenovation = 'luxuryRenovation',
    MarbleWorktop = 'marbleWorktop',
    Masonry = 'masonry',
    MelamineWorktop = 'melamineWorktop',
    MetalCabinet = 'metalCabinet',
    MetalFabrication = 'metalFabrication',
    MetalWorktop = 'metalWorktop',
    MirrorPose = 'mirrorPose',
    MirrorRepair = 'mirrorRepair',
    MobilePedestals = 'mobilePedestals',
    MoistureTreatment = 'moistureTreatment',
    MosquitoNetInstallation = 'mosquitoNetInstallation',
    MosquitoNetRepair = 'mosquitoNetRepair',
    NaturalStoneWorktop = 'naturalStoneWorktop',
    NewHouseBuild = 'newHouseBuild',
    OldFurnitureRestoration = 'oldFurnitureRestoration',
    OutdoorChimneyBuild = 'outdoorChimneyBuild',
    OutdoorFurniture = 'outdoorFurniture',
    OutdoorKitchenDesign = 'outdoorKitchenDesign',
    OutdoorLightingInstallation = 'outdoorLightingInstallation',
    ParquetColor = 'parquetColor',
    ParquetInstallation = 'parquetInstallation',
    ParquetRenovation = 'parquetRenovation',
    ParquetRepair = 'parquetRepair',
    PavingStone = 'pavingStone',
    PelletStoveCleaning = 'pelletStoveCleaning',
    PelletStoveInstallation = 'pelletStoveInstallation',
    PelletStoveRepair = 'pelletStoveRepair',
    PepoleWithReducedMobilityLayout = 'pepoleWithReducedMobilityLayout',
    PergolaBuild = 'pergolaBuild',
    Plastering = 'plastering',
    PlasteringPlaster = 'plasteringPlaster',
    PlasterRepair = 'plasterRepair',
    PlayroomLayout = 'playroomLayout',
    PlinthInstallation = 'plinthInstallation',
    PoolAndSpaRepair = 'poolAndSpaRepair',
    PoolCover = 'poolCover',
    PoolMaintenanceAndCleaning = 'poolMaintenanceAndCleaning',
    PortalInstallation = 'portalInstallation',
    PortalRepair = 'portalRepair',
    PortalSale = 'portalSale',
    PrefabricatedHouse = 'prefabricatedHouse',
    PrintedConcrete = 'printedConcrete',
    ProjectedInsulation = 'projectedInsulation',
    PVCCarpentry = 'pVCCarpentry',
    PVCCladding = 'pVCCladding',
    QuartzWorktop = 'quartzWorktop',
    RailingInstallation = 'railingInstallation',
    ReceptionDesk = 'receptionDesk',
    RecessedLightingInstallation = 'recessedLightingInstallation',
    RefrigeratedDisplay = 'refrigeratedDisplay',
    RemovablePartition = 'removablePartition',
    ReplacementOfAboveGroundPoolLiner = 'replacementOfAboveGroundPoolLiner',
    ResidentialWindowTinting = 'residentialWindowTinting',
    RestaurationAfterWaterDamage = 'restaurationAfterWaterDamage',
    RestorationFurniture = 'restorationFurniture',
    RestorationOfOldFurniture = 'restorationOfOldFurniture',
    RetainingWallBuild = 'retainingWallBuild',
    RollerShutterInstallation = 'rollerShutterInstallation',
    RoofCleaningAndDefoaming = 'roofCleaningAndDefoaming',
    RoofDeckLayout = 'roofDeckLayout',
    RoofFlashingInstallation = 'roofFlashingInstallation',
    RoofSoffitInstallation = 'roofSoffitInstallation',
    RoofSoffitRepair = 'roofSoffitRepair',
    RoofWaterproofing = 'roofWaterproofing',
    RoofWindowInstallation = 'roofWindowInstallation',
    SaleAndInstalOfWindaowDoorShutterAndBlind = 'saleAndInstalOfWindaowDoorShutterAndBlind',
    SaleCounter = 'saleCounter',
    SaleOfGardenFurniture = 'saleOfGardenFurniture',
    SaleOfWorkPlan = 'saleOfWorkPlan',
    SalesTable = 'salesTable',
    SaunaInstallation = 'saunaInstallation',
    SaunaRepair = 'saunaRepair',
    SaunaSale = 'saunaSale',
    SeamlessBathroom = 'seamlessBathroom',
    Shelving = 'shelving',
    ShoesCabinet = 'shoesCabinet',
    Showcase = 'showcase',
    ShowcaseLight = 'showcaseLight',
    ShowerDoorInstallation = 'showerDoorInstallation',
    ShowerDoorRepair = 'showerDoorRepair',
    ShowerDoorSale = 'showerDoorSale',
    ShowerInstallation = 'showerInstallation',
    ShutterInstallation = 'shutterInstallation',
    Sideboard = 'sideboard',
    SidingRepair = 'sidingRepair',
    SidingSale = 'sidingSale',
    Sign = 'sign',
    SitePlan = 'sitePlan',
    SitePreparation = 'sitePreparation',
    SlindingDoorInstallation = 'slindingDoorInstallation',
    SlindingDoorRepair = 'slindingDoorRepair',
    SolarSwimmingPoolWaterHeater = 'solarSwimmingPoolWaterHeater',
    SolidParquetSale = 'solidParquetSale',
    SoundAndAcousticInsulation = 'soundAndAcousticInsulation',
    SpaInstallation = 'spaInstallation',
    SpaSale = 'spaSale',
    StairInstallation = 'stairInstallation',
    StairRepair = 'stairRepair',
    SteelFabrication = 'steelFabrication',
    StoneFacing = 'stoneFacing',
    StoneSale = 'stoneSale',
    Stool = 'stool',
    StorageUnit = 'storageUnit',
    StretchCeiing = 'stretchCeiing',
    SubjectMastery = 'subjectMastery',
    SummerKitchen = 'summerKitchen',
    SwimingPoolRenovation = 'swimingPoolRenovation',
    SwimmingPoolRenovation = 'swimmingPoolRenovation',
    Table = 'table',
    TextileDecorationCurtainAndVeil = 'textileDecorationCurtainAndVeil',
    ThreeDComputerGraphic = 'threeDComputerGraphic',
    TiledWorktop = 'tiledWorktop',
    TilesSale = 'tilesSale',
    Tiling = 'tiling',
    TimberFrameHouse = 'timberFrameHouse',
    TinyHouseBuild = 'tinyHouseBuild',
    TitleRepair = 'titleRepair',
    TitlPainting = 'titlPainting',
    ToiletRenovation = 'toiletRenovation',
    UnderlaymentLaying = 'underlaymentLaying',
    Upholstery = 'upholstery',
    VanityUnitInstallation = 'vanityUnitInstallation',
    VinylFenceInstallation = 'vinylFenceInstallation',
    VinylFlooringInsatllation = 'vinylFlooringInsatllation',
    VinylFlooringSale = 'vinylFlooringSale',
    VinylFloorRepair = 'vinylFloorRepair',
    WallPanel = 'wallPanel',
    WallpaperLaying = 'wallpaperLaying',
    WardrobeAndClosetSale = 'wardrobeAndClosetSale',
    WardrobeRoomAndCloset = 'wardrobeRoomAndCloset',
    WashroomDesign = 'washroomDesign',
    WashroomRenovation = 'washroomRenovation',
    Waterproofing = 'waterproofing',
    WaterproofingOfWoodenDeck = 'waterproofingOfWoodenDeck',
    WaxedConcrete = 'waxedConcrete',
    Welding = 'welding',
    WindowFilm = 'windowFilm',
    WindowInstallation = 'windowInstallation',
    WindowRemplacement = 'windowRemplacement',
    WindowRepair = 'windowRepair',
    WindowSale = 'windowSale',
    WindowSeal = 'windowSeal',
    WindowSillInstallation = 'windowSillInstallation',
    WineCellar = 'wineCellar',
    WineCellarDedicatedRoom = 'wineCellarDedicatedRoom',
    WineCellarDesign = 'wineCellarDesign',
    WineCellarLayout = 'wineCellarLayout',
    WireMeshInstallation = 'wireMeshInstallation',
    WoodDeckCleaning = 'woodDeckCleaning',
    WoodDeckLayout = 'woodDeckLayout',
    WoodDeckMaintenance = 'woodDeckMaintenance',
    WoodDeckStain = 'woodDeckStain',
    WoodenCabinet = 'woodenCabinet',
    WoodenDeckBuild = 'woodenDeckBuild',
    WoodenDeckLightingInstallation = 'woodenDeckLightingInstallation',
    WoodenDeckRepair = 'woodenDeckRepair',
    WoodenFenceRepair = 'woodenFenceRepair',
    WoodenPatioLightingInstallation = 'woodenPatioLightingInstallation',
    WoodFinish = 'woodFinish',
    WoodStoveInstallation = 'woodStoveInstallation',
    WoodStoveRepair = 'woodStoveRepair',
    WoodWorktop = 'woodWorktop',
    WorktopLaying = 'worktopLaying',
    WorktopRepair = 'worktopRepair',
    WorktopSale = 'worktopSale',
    WroughtIronFenceInstallation = 'wroughtIronFenceInstallation',
    WroughtIronFenceRepair = 'wroughtIronFenceRepair',
    GlazingFilm = 'glazingFilm',
    CustomCabinet = 'customCabinet',
    StaircaseDesign = 'staircaseDesign',
    PharmacyLayoutAndFurniture = 'pharmacyLayoutAndFurniture',
    RealEstateAgencyLayoutAndFurniture = 'realEstateAgencyLayoutAndFurniture',
    ButcherShopLayoutAndFurniture = 'butcherShopLayoutAndFurniture',
    BakeryLayoutAndFurniture = 'bakeryLayoutAndFurniture',
    GroceryLayoutAndFurniture = 'groceryLayoutAndFurniture',
    CheeseDairyLayoutAndFurniture = 'cheeseDairyLayoutAndFurniture',
    BeautyInstituteLayoutAndFurniture = 'beautyInstituteLayoutAndFurniture',
    HairdresserLayoutAndFurniture = 'hairdresserLayoutAndFurniture',
    BarLayoutAndFurniture = 'barLayoutAndFurniture',
    FastFoodLayoutAndFurniture = 'fastFoodLayoutAndFurniture',
    HotelLayoutAndFurniture = 'hotelLayoutAndFurniture',
    RestaurantLayoutAndFurniture = 'restaurantLayoutAndFurniture',
    StaircaseAndGuardrail = 'staircaseAndGuardrail',
    EventLayoutAndFurniture = 'eventLayoutAndFurniture',
    PoolDesign = 'poolDesign',
}

export enum PublishedProjectId {
    Default = 'default',
    MeetingTable = 'meetingTable',
    SwimmingPoolBuild = 'swimmingPoolBuild',
    SwimingPoolLightingInstallation = 'swimingPoolLightingInstallation',
    PoolDeckDesignAndLayout = 'poolDeckDesignAndLayout',
    AboveGroundPool = 'aboveGroundPool',
    StoneLaying = 'stoneLaying',
    WindowAndDoorWindow = 'windowAndDoorWindow',
    SlidingBayWindow = 'slidingBayWindow',
    FrontDoorAndService = 'frontDoorAndService',
    ShutterAndAwning = 'shutterAndAwning',
    PortalAndGate = 'portalAndGate',
    DelimitationAndFence = 'delimitationAndFence',
    LayoutAndBuildOfPoolHouse = 'layoutAndBuildOfPoolHouse',
    PorchDesignAndLayout = 'porchDesignAndLayout',
    DesignAndBuildOfGardenSheds = 'designAndBuildOfGardenSheds',
    ArborDesignAndBuild = 'arborDesignAndBuild',
    Blinds = 'blinds',
    InteriorDoor = 'interiorDoor',
    CustomGlassWall = 'customGlassWall',
    PartitionWall = 'partitionWall',
    TerraceDesignAndBuild = 'terraceDesignAndBuild',
    CustomWardrobe = 'customWardrobe',
    BuffetAndSideboard = 'buffetAndSideboard',
    OfficePedestals = 'officePedestals',
    Trunk = 'trunk',
    ChestsOfDrawersAndCabinet = 'chestsOfDrawersAndCabinet',
    CustomShelves = 'customShelves',
    Storage = 'storage',
    CustomKitchenCupboard = 'customKitchenCupboard',
    ClosetDoor = 'closetDoor',
    CustomCupboard = 'customCupboard',
    CustomPantry = 'customPantry',
    WineCellarDesignAndLayout = 'wineCellarDesignAndLayout',
    HallwayCabinetAndShoes = 'hallwayCabinetAndShoes',
    TvUnit = 'tvUnit',
    DiningTableHighTableBarTable = 'diningTableHighTableBarTable',
    LowTable = 'lowTable',
    SideTableAndBedsideTable = 'sideTableAndBedsideTable',
    CounterBar = 'counterBar',
    DressingTable = 'dressingTable',
    SofaAndPedestalTable = 'sofaAndPedestalTable',
    Console = 'console',
    BenchAndStool = 'benchAndStool',
    BenchAndBenchSeat = 'benchAndBenchSeat',
    Pouf = 'pouf',
    Sofa = 'sofa',
    EndOfBed = 'endOfBed',
    BarChairAndStool = 'barChairAndStool',
    ChairAndArmchair = 'chairAndArmchair',
    CustomBed = 'customBed',
    Bedhead = 'bedhead',
    Nightstand = 'nightstand',
    BedroomDesign = 'bedroomDesign',
    ChildrenBedroomDesign = 'childrenBedroomDesign',
    BedroomLayout = 'bedroomLayout',
    KitchenBuild = 'kitchenBuild',
    OutdoorKitchenBuild = 'outdoorKitchenBuild',
    CustomKitchenCabinet = 'customKitchenCabinet',
    CustomKitchenBaseCabinet = 'customKitchenBaseCabinet',
    KitchenIsland = 'kitchenIsland',
    KitchenBack = 'kitchenBack',
    CustomLight = 'customLight',
    WallPaneling = 'wallPaneling',
    GreenWall = 'greenWall',
    ShowerDoor = 'showerDoor',
    CHRLayoutAndFurniture = 'chrLayoutAndFurniture',
    ShopLayoutAndFurniture = 'shopLayoutAndFurniture',
    WorkspaceLayoutAndFurniture = 'workspaceLayoutAndFurniture',
    HouseOutsideLayoutAndFurniture = 'houseOutsideLayoutAndFurniture',
    HouseInteriorLayoutAndFurniture = 'houseInteriorLayoutAndFurniture',
    Claustra = 'claustra',
    CustomBuiltInCabinet = 'customBuiltInCabinet',
    CustomCurtainAndVeil = 'customCurtainAndVeil',
    CustomGarageDoor = 'customGarageDoor',
    CustomLibrary = 'customLibrary',
    CustomRugs = 'customRugs',
    CustomWorkPlan = 'customWorkPlan',
    Desk = 'desk',
    WallHanging = 'wallHanging',
    VerandaDesignAndBuild = 'verandaDesignAndBuild',
    PergolaConstruction = 'pergolaConstruction',
    Mirror = 'mirror',
    GlassWindowGlazingAndMirrorCutting = 'glassWindowGlazingAndMirrorCutting',
    GreenhouseBuild = 'greenhouseBuild',
    InstallationOfCredenza = 'installationOfCredenza',
    GardenPavilionDesignAndBuild = 'gardenPavilionDesignAndBuild',
    Stairs = 'stairs',
    Guardrail = 'guardrail',
}

export type ProjectId = PublishedProjectId | DeprecatedProjectId;

export default ProjectId;
